<template>
  <v-container fluid class="pt-0 mt-0">
    <v-row>
      <v-spacer />
      <v-col cols="12">
        <v-card class="mx-auto">
          <v-toolbar color="teal" dark class="text-xs-center">
            <v-toolbar-title style="color: white">Site Admin</v-toolbar-title>
          </v-toolbar>
        </v-card>
      </v-col>
      <v-spacer />
    </v-row>
    <v-row>
      <v-spacer />
      <v-col cols="12">
        <v-tabs style="max-width:100%" v-if="adminFunctions"  show-arrows>
          <v-tab dense v-for="tab in adminFunctions" :key="tab.adminFunction" class="align-left">
            <v-icon left> {{ tab.icon }} </v-icon>
            {{ tab.adminFunction }}
          </v-tab>
          <v-spacer />
          <v-tab-item key="User Admin">
            <user-admin />
          </v-tab-item>
          <v-tab-item key="Stats">
            <user-stats />
          </v-tab-item>
          <v-tab-item key="News">
            <news-list />
          </v-tab-item>
          <v-tab-item key="Journal">
            <journal-list />
          </v-tab-item>
          <v-tab-item key="Nurseries">
            <list-admin listid="4" />
          </v-tab-item>
          <v-tab-item key="Societies">
            <list-admin listid="1" />
          </v-tab-item>
          <v-tab-item key="Resources">
            <list-admin listid="2" />
          </v-tab-item>
          <v-tab-item key="Gardens">
            <list-admin listid="5" />
          </v-tab-item>
        </v-tabs>
      </v-col>
      <v-spacer />
    </v-row>
  </v-container>
</template>

<script>
import UserAdmin from "../components/UserAdmin";
import UserStats from "../components/UserStats";
import ListAdmin from "../components/ListAdmin";
import NewsList from "../components/NewsList";
import JournalList from "../components/JournalList";

import userFunctions from "../functions/userFunctions";

export default {
  components: {
    "user-admin": UserAdmin,
    "user-stats": UserStats,
    "list-admin": ListAdmin,
    "news-list": NewsList,
    "journal-list": JournalList,
  },

  name: "SiteAdmin",
  methods: {
  },
  data: () => ({
    adminFunctions: [
      { adminFunction: "User Admin", icon: "mdi-account" },
      { adminFunction: "Stats", icon: "mdi-table" },
      { adminFunction: "News", icon: "mdi-newspaper" },
      { adminFunction: "Journals", icon: "mdi-newspaper-variant-outline" },
      { adminFunction: "Nurseries", icon: "mdi-storefront-outline" },
      { adminFunction: "Societies", icon: "mdi-web" },
      { adminFunction: "Resources", icon: "mdi-web" },
      { adminFunction: "Gardens", icon: "mdi-web" },
    ],
  }),
  beforeMount() {
    if (!(userFunctions.currentUserIsModerator() || userFunctions.currentUserIsOwner())) {
      this.$router.push("/");
    }
    userFunctions.updateLastViewed('admin');
  },
};
</script>

<style scoped>
.palm-site-green {
  background-color: rgb(176, 217, 173);
}

.v-tab {
  justify-content: left
}
</style>
